module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_52455461_XL-small-9b5ebd716c6fcce73a17b9a5293d8d57.jpg";